export const environment = {
  production: false,
  apiUrl: 'https://api-dev.cartco.in/api',
  wsUrl: 'https://api-dev.cartco.in',
  locationId: 'makthal',
  locationName: 'Makthal Store',
  locationCity: 'Makthal',
  locationState: 'Telangana',
};
